/**
 * For top menu
 * 
 */
export function MenuInner() {
  return (
    <>
      {/* <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.VIEW_USERSLIST]} >
        <MenuItem title='Lista de usuarios' to='/listaUsuarios' />
      </PermissionsGate> */}
    </>
  )
}
